export default "__VITE_ASSET__5dca54a9__"